"use client";

import { Search, X } from "lucide-react";

/** Suchfeld des Lexikons – kontrolliert vom Overview-Container. */
export default function SearchBar({
  value,
  onChange,
  resultCount,
}: {
  value: string;
  onChange: (value: string) => void;
  resultCount: number;
}) {
  return (
    <div className="w-full max-w-xl">
      <div className="relative">
        <Search
          size={18}
          className="absolute left-5 top-1/2 -translate-y-1/2 text-ink-faint pointer-events-none"
          aria-hidden="true"
        />
        <input
          type="search"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Begriff suchen …"
          aria-label="Lexikon-Begriff suchen"
          className="w-full rounded-full bg-white pl-12 pr-12 py-4 text-base text-ink placeholder:text-ink-faint focus:outline-none focus:ring-2 focus:ring-accent/40 transition-shadow"
        />
        {value && (
          <button
            onClick={() => onChange("")}
            aria-label="Suche zurücksetzen"
            className="absolute right-4 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center rounded-lg text-ink-faint hover:bg-paper-deep hover:text-ink transition-colors cursor-pointer"
          >
            <X size={16} />
          </button>
        )}
      </div>
      <p className="mt-3 text-sm text-ink-faint text-center" aria-live="polite">
        <span className="font-bold text-ink tnum">{resultCount}</span>{" "}
        {resultCount === 1 ? "Begriff" : "Begriffe"}
      </p>
    </div>
  );
}
